import * as React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { Feather } from "@expo/vector-icons";
import { useRouter } from "expo-router";
import { SafeAreaView } from "react-native-safe-area-context";

//import { useRouterSearchParams } from "@/hooks/router";

function FollowerHeader(): React.JSX.Element {
  const router = useRouter();

  //const username = useRouterSearchParams("username");

  return (
    <SafeAreaView style={styles.safeArea} edges={["top"]}>
      <View style={styles.headerContainer}>
        <TouchableOpacity
          style={styles.backButton}
          onPress={() => router.back()}
        >
          <Feather name="arrow-left" size={24} color="black" />
        </TouchableOpacity>
        <View style={styles.tabsContainer}>
          <Text style={styles.text}>Followers</Text>
        </View>
      </View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  backButton: {
    position: "absolute",
    left: 15,
  },
  headerContainer: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "center",
    paddingHorizontal: 10,
    paddingVertical: 5,
    position: "relative",
  },
  safeArea: {
    backgroundColor: "#fff",
  },
  tabsContainer: {
    alignItems: "center",
    flex: 1,
    justifyContent: "center",
  },
  text: {
    fontSize: 16,
  },
});

export default FollowerHeader;
